import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map, switchMap } from 'rxjs/operators';
import { ApiEndPoints } from 'src/app/api-end-points';
import { Globals } from 'src/app/globals';
import { from, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(private http: HttpClient, private _apiEndPoints: ApiEndPoints, private globals: Globals) {
    Inject(ApiEndPoints)
  }

  public getFilterDtls(userId) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['getLoginIdHierarchy']+userId;
    return this.http.get(url,options).pipe(map(response => {
      return response;
    }));
  }

  public getSFFilterDtls(userId) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['getSFLoginIdHierarchy']+userId;
    return this.http.get(url,options).pipe(map(response => {
      return response;
    }));
  }

  public getStates() {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['fetchStates'];
    return this.http.post(url,{},options).pipe(map(response => {
      return response;
    }));
  }

  public getCities(state) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let body = {
      "stateName": state
    }
    let url = this._apiEndPoints.filteredEndPoints['fetchCities'];
    return this.http.post(url,body,options).pipe(map(response => {
      return response;
    }));
  }

  public fetchLicenceMasterDetails(){
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['fetchLicenceMasterDetails'];
    return this.http.post(url,{},options).pipe(map(response => {
      return response;
    }));
  }

  public fetchAdoBodDetails(body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['fetchAdoBodDetails'];
    return this.http.post(url,body,options).pipe(map(response => {
      return response;
    }));
  }

  public getSampleUploadFormats(body) {
    let url = "";
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    url = this._apiEndPoints.filteredEndPoints['fetchUploadFormats'];
    return this.http.post(url, body, options).pipe(map(response => {
      return response;
    }));
  }

  public fetchMasterProductDetails() {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['fetchMasterProductDetails'];
    return this.http.post(url,{},options).pipe(map(response => {
      return response;
    }));
  }

  public logoutService(sessionId) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['logoutAuthenticatedUser']+sessionId;
    return this.http.post(url,options).pipe(map(response => {
      return response;
    }));
  }

  public fetchAgentDataVisibility(body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['getAgentDataVisibility'];
    return this.http.post(url,body,options).pipe(map(response => {
      return response;
    }));
  }
  public fetchCategorySubCategoryDtls() {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['fetchCategorySubCategoryDtls'];
    return this.http.post(url,{},options).pipe(map(response => {
      return response;
    }));
  }
  public getIntermediaryAgentCodes(body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['fetchIntermediaryAgentCodes'];
    return this.http.post(url,body,options).pipe(map(response => {
      return response;
    }));
  }

  public getPreviousAgCode(body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['fetchPreviousAgCode'];
    return this.http.post(url,body,options).pipe(map(response => {
      return response;
    }));
  }

  public getBpPartnerCodes(body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['fetchBpPartnerCodes'];
    return this.http.post(url,body,options).pipe(map(response => {
      return response;
    }));
  }

  public fetchPartnerCategoryDtls(body) {
    let url = "";
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    url = this._apiEndPoints.filteredEndPoints['fetchPartnerCategoryMasterData'];
    return this.http.post(url, body, options).pipe(map(response => {
      return response;
    }));
  }

  public getNetworkHospitalizationDetails(body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['fetchNetworkHospitalDetails'];
    return this.http.post(url, body, options).pipe(map(response => {
      return response;
    }));
  }

  public fetchNetworkHospitalList(body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['fetchNetworkHospitalList'];
    return this.http.post(url, body, options).pipe(map(response => {
      return response;
    }));
  }

  public getGarageSearchDetails(body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['fetchGarageDetails'];
    return this.http.post(url, body, options).pipe(map(response => {
      return response;
    }));
  }

  public fetchAgentCodesForProduct(body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['fetchAgentCodesForProduct'];
    return this.http.post(url,body,options).pipe(map(response => {
      return response;
    }));
  }

  public policyDocumentObject(body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['policyDocumentObject'];
    return this.http.post(url,body,options).pipe(map(response => {
      return response;
    }));
  }

  public healthCardDownloadByZip(body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['healthCardDownload'];
    return this.http.post(url,body,options).pipe(map(response => {
      return response;
    }));
  }

  getMotorRenewalDoc(body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let messageurl = this._apiEndPoints.filteredEndPoints['generateMotorPrint'];
    return this.http.post(messageurl, body, options).pipe(map(response => {
      return response;
    }));
  }

  getMotorDoc(body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let messageurl = this._apiEndPoints.filteredEndPoints['printPolicyDocument'];
    return this.http.post(messageurl, body, options).pipe(map(response => {
      return response;
    }));
  }

  public getAPIKey(agentId) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    const headers = new HttpHeaders().append('Accept', 'application/json');
    let params = new HttpParams().set("agentcode",agentId);
    let url = this._apiEndPoints.filteredEndPoints['getApiKey'];
    return this.http.get(url, {headers,params}).pipe(map(response => {
      return response;
    }));
  }

  public getPolicyDetails(body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['getPolicyDetailsForClaimIntimation'];
    return this.http.post(url, body, options).pipe(map(response => {
      return response;
    }));
  }

  public getHealthLoadPolicy(body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['fetchHealthClaimLodPolicy'];
    return from(this.globals.vConnectEncryptAndEncode(JSON.stringify(body))).pipe(
      switchMap(encryptedString => {
        const request = { encRequest: encryptedString };
        return this.http.post(url, request, options);
      }),
      map(response => response)
    );
  }

  public fetchSFMasterBranchDetails(body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['fetchSFMasterBranchDetails'];
    return this.http.post(url, body, options).pipe(map(response => {
      return response;
    }));
  }

  public fetchPartnerCategoriesFilter(body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['fetchPartnerCategoriesFilter'];
    return this.http.post(url, body, options).pipe(map(response => {
      return response;
    }));
  }

  public fetchChannelCategoryDetails(body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['fetchChannelCategoryDetails'];
    return this.http.post(url, body, options).pipe(map(response => {
      return response;
    }));
  }

  public fetchTrainersMasterData(body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['fetchTrainersMasterData'];
    return this.http.post(url, body, options).pipe(map(response => {
      return response;
    }));
  }

  public fetchBPCodes(body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['fetchBPCodes'];
    return this.http.post(url, body, options).pipe(map(response => {
      return response;
    }));
  }

  public fetchHierarchyDetailsByIsHierarchy(body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['fetchHierarchyDetailsByIsHierarchy'];
    return this.http.post(url, body, options).pipe(map(response => {
      return response;
    }));
  }

  public fetchFilterHierarchyDetail(body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['fetchFilterHierarchyDetail'];
    return this.http.post(url, body, options).pipe(map(response => {
      return response;
    }));
  }

  public fetchProspectChannelsAndCCModules(body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['fetchProspectChannelsAndCCModules'];
    return this.http.post(url, body, options).pipe(map(response => {
      return response;
    }));
  }

  getPosition(): Promise<any> {
    //getCurrentPosition
    return new Promise((resolve, reject) => {
      navigator.geolocation.watchPosition(resp => {// NOSONAR
          resolve({lng: resp.coords.longitude, lat: resp.coords.latitude});
        },
        err => {
          reject(err);
        });
    });
  }

  public commonServicePrintPolicy(body:any){
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let Url = this._apiEndPoints.filteredEndPoints['GenerateBase64Pdf'];
    return this.http.post(Url, body, options).pipe(map(response => {
      return response;
    }));
  }

  public serviceCallForCommercial(body: any){
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let Url = this._apiEndPoints.filteredEndPoints['getTokenForDBSByUserId'];
    return this.http.post(Url, body, options).pipe(map(response => {
      return response;
    }));
  }

  public serviceCallForCPM(body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['fetchCpm'];
    return this.http.post(url,body,options).pipe(map(response => {
      return response;
    }));
  }

  public fetchBragUnitMasterDetails(body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['fetchBragUnitMasterDetails'];
    return this.http.post(url,body,options).pipe(map(response => {
      return response;
    }));
  }

  public fetchAccChannelSubChannelMasterDtls(body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['fetchAccChannelSubChannelMasterDtls'];
    return this.http.post(url,body,options).pipe(map(response => {
      return response;
    }));
  }

  public saveUserActionTrackingDetails(module,loginId) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let request = {
      "loginId": loginId,
      "moduleName": module
    }
    let url = this._apiEndPoints.filteredEndPoints['saveUserActionTrackingDetails'];
    return this.http.post(url, request, options).pipe(map(response => {
      return response;
    }));
  }

  public speak(text: string): void {
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = 'en-US'; // You can change the language
    utterance.rate = 0.2;
    speechSynthesis.speak(utterance);
  }

  public getAIEpicPath(userType,body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['epicxFetchQuickProcess'] + userType;
    return this.http.post(url, body, options).pipe(map(response => {
      return response;
    }));
  }

  public fetchOmniDocsContentJson(body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['fetchOmniDocsContentJson'];
    return this.http.post(url,body,options).pipe(map(response => {
      return response;
    }));
  }

  public init() {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['init'];
    return this.http.get(url,options).pipe(map(response => {
      return response;
    }));
  }
  
  public vConnectInit() {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['vConnectInit'];
    return this.http.get(url,options).pipe(map(response => {
      return response;
    }));
  }

  public iloungeInit() {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['iloungeInit'];
    return this.http.post(url,{},options).pipe(map(response => {
      return response;
    }));
  }
  
}